module.exports = __webpack_public_path__ + "static/media/skills-mapping-img-002.4e33fc0d.jpg";